import React from "react";
import { ToolRendererProps } from "./types";

export const RunTerminalCommandToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const terminalCommand = args?.command || "";
  return terminalCommand
    ? renderWithErrorIfFailed(
        <code className="text-xs text-secondary-n-400 bg-secondary-n-900 px-2 py-1 rounded">
          {terminalCommand}
        </code>,
      )
    : getFallbackText();
};

export const RestartDevServerToolRenderer: React.FC<ToolRendererProps> = ({
  renderWithErrorIfFailed,
}) => {
  return (
    <>
      {renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400">
          Restarted Dev Server
        </span>,
      )}
    </>
  );
};
